import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { getIntegrationFolder } from './app/shared/utils/integration-folder';
import { environment } from './environments/environment';
declare let __webpack_public_path__: string;

// WordPress enqueues the lazy chunks on demand, and webpack resolves them against the
// public path. The default empty one resolves against the page URL (a WP 404 page), so
// point it at the folder of main.js. `currentScript` is null (or a combined file) when a
// WordPress optimisation plugin defers or merges scripts: look the main script up by URL.
const integrationFolder = getIntegrationFolder([
  (document.currentScript as HTMLScriptElement | null)?.src,
  document.querySelector<HTMLScriptElement>(
    'script[src*="/assets/js/integration/main."]'
  )?.src,
]);

if (integrationFolder) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- webpack turns this assignment into its public path
  __webpack_public_path__ = integrationFolder;
}

if (environment.production) {
  enableProdMode();
}

try {
  platformBrowser().bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  });
} catch (err) {
  console.error(err);
}
